import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import { PageSkeleton } from "./components/blocks/PageHero";
import { BASENAME } from "./lib/i18n";

const Tjenester = lazy(() => import("./pages/Tjenester"));
const Tjeneste = lazy(() => import("./pages/Tjeneste"));
const Selskaper = lazy(() => import("./pages/Selskaper"));
const Selskap = lazy(() => import("./pages/Selskap"));
const Aktuelt = lazy(() => import("./pages/Aktuelt"));
const Artikkel = lazy(() => import("./pages/Artikkel"));
const Markeder = lazy(() => import("./pages/Markeder"));
const OmOss = lazy(() => import("./pages/OmOss"));
const Strategi = lazy(() => import("./pages/Strategi"));
const Ledelse = lazy(() => import("./pages/Ledelse"));
const Baerekraft = lazy(() => import("./pages/Baerekraft"));
const Karriere = lazy(() => import("./pages/Karriere"));
const Kontakt = lazy(() => import("./pages/Kontakt"));
const BliEnDel = lazy(() => import("./pages/BliEnDel"));
const Investor = lazy(() => import("./pages/Investor"));
const Personvern = lazy(() => import("./pages/Personvern"));
const NotFound = lazy(() => import("./pages/NotFound"));

const S = ({ children }) => <Suspense fallback={<PageSkeleton />}>{children}</Suspense>;

const ROUTES = [
  ["/tjenester", Tjenester], ["/tjenester/:slug", Tjeneste],
  ["/selskaper", Selskaper], ["/selskaper/:slug", Selskap],
  ["/aktuelt", Aktuelt], ["/aktuelt/:slug", Artikkel],
  ["/markeder", Markeder],
  ["/om-oss", OmOss], ["/om-oss/strategi", Strategi], ["/om-oss/ledelse", Ledelse],
  ["/om-oss/baerekraft", Baerekraft], ["/om-oss/karriere", Karriere], ["/om-oss/kontakt", Kontakt],
  ["/bli-en-del-av-eqva", BliEnDel], ["/investor", Investor], ["/personvern", Personvern],
];

function App() {
  return (
    <div className="App">
      {/* /en is the same site in English: the router mounts under that prefix, so every Link stays as written */}
      <BrowserRouter basename={BASENAME}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            {ROUTES.map(([path, C]) => <Route key={path} path={path} element={<S><C /></S>} />)}
            <Route path="*" element={<S><NotFound /></S>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
